<mat-card class="search-result-card">
  <div class="card-image-container" [style.height.px]="imageHeight">
    <img
      crossorigin="anonymous"
      [ngSrc]="getImageUrl()"
      class="card-image"
      [class.has-drawing-overlay]="item.overlayRect !== undefined"

      loading="lazy"
      width="{{ imageWidth }}"
      height="{{ imageHeight }}"
      alt="Embeddings image"
      (click)="onFit()"/>

    <!-- Mask SVG overlay — vectorised contour projected to card coordinate space -->
    @if (showMask && maskColor && item.maskOverlay) {
      <svg class="drawing-overlay" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <path [attr.d]="item.maskOverlay"
              [attr.fill]="maskColor"
              fill-rule="evenodd"
              fill-opacity="0.35"
              stroke="none" />
      </svg>
    }

    <!-- Bbox SVG overlay -->
    @if (showBbox && getDrawingPolygonPoints(); as points) {
      <svg class="drawing-overlay"
           viewBox="0 0 100 100"
           preserveAspectRatio="none"
           aria-hidden="true">
        <polygon [attr.points]="points"
                 [attr.stroke]="item.drawingStyle || 'var(--mat-sys-primary)'"
                 stroke-width="2"
                 fill="transparent"
                 vector-effect="non-scaling-stroke" />
      </svg>
    }

    <div class="image-overlay top">
      <span class="index-badge">#{{ index + 1 }}</span>
      @if (item.scoreColor) {
        <span class="confidence-badge" [style.background-color]="item.scoreColor">
          <mat-icon class="confidence-badge__icon">task_alt</mat-icon>
          {{ item.score | percent }}
        </span>
      } @else {
        <span class="confidence-badge confidence-badge--skeleton" aria-hidden="true"></span>
      }
    </div>
    <div class="image-overlay bottom">
        @if (item.productType) {
            <span class="orientation-badge">
                {{translateDirection(item.productType)}}
            </span>
        }
    </div>
  </div>

  <mat-card-actions class="card-actions">
    <button matIconButton (click)="onFit()" class="feedback-button mat-icon-button-medium">
      <mat-icon>location_on</mat-icon>
    </button>
    <span class="coordinates">{{ item.centroid[1] | number }}, {{ item.centroid[0] | number }}</span>
    <div class="spacer"></div>
    @if (showFeedback) {
      <button matIconButton (click)="onThumbsUp()" [class.up]="feedback === 'up'" class="feedback-button mat-icon-button-medium">
        <mat-icon>thumb_up</mat-icon>
      </button>
      <button matIconButton (click)="onThumbsDown()" [class.down]="feedback === 'down'" class="feedback-button mat-icon-button-medium">
        <mat-icon>thumb_down</mat-icon>
      </button>
    }
  </mat-card-actions>
</mat-card>
